if ( ! customElements.get('category-preview') ) {

	class CategoryPreview extends HTMLElement {

		connectedCallback(){

			this.cards = Array.from(this.querySelectorAll('[data-category-card]'));
			this.openCard = null;

			this._onClick = this.onClick.bind(this);
	
	
			this._onKeydown = this.onKeydown.bind(this);
			this._onBlockSelect = this.onBlockSelect.bind(this);
			this._onBlockDeselect = this.onBlockDeselect.bind(this);

			this.addEventListener('click', this._onClick);
			document.addEventListener('keydown', this._onKeydown);

			if ( window.Shopify && Shopify.designMode ) {
				document.addEventListener('shopify:block:select', this._onBlockSelect);
				document.addEventListener('shopify:block:deselect', this._onBlockDeselect);
			}

		}

		disconnectedCallback(){
			this.removeEventListener('click', this._onClick);
			document.removeEventListener('keydown', this._onKeydown);
			document.removeEventListener('shopify:block:select', this._onBlockSelect);
			document.removeEventListener('shopify:block:deselect', this._onBlockDeselect);
		}

		onClick(e){

			const card = e.target.closest('[data-category-card]');
			if ( ! card || ! this.contains(card) ) return;

			const isOpen = card === this.openCard;

			// The close button closes; the toggle (which may be a link styled as a button)
			// only opens/closes the preview; other links (View all, products) navigate as normal.
			if ( e.target.closest('[data-category-close]') ) {
				this.close(card, true);
				return;
			}
			if ( e.target.closest('[data-category-toggle]') ) {
				e.preventDefault();
				isOpen ? this.close(card, false) : this.open(card);
				return;
			}
			if ( e.target.closest('a') ) return;

			if ( ! isOpen ) {
				this.open(card);
			} else if ( ! e.target.closest('[data-category-strip]') ) {
				this.close(card, false);
			}

		}

		onKeydown(e){
			// Links acting as the toggle get role="button", so Space has to activate them too.
			if ( e.key === ' ' && e.target instanceof HTMLAnchorElement && e.target.matches('[data-category-toggle]') && this.contains(e.target) ) {
				e.preventDefault();
				e.target.click();
				return;
			}
			if ( e.key !== 'Escape' || ! this.openCard ) return;
			const card = this.openCard;
			this.close(card, card.contains(document.activeElement));
		}

		open(card){

			if ( this.openCard && this.openCard !== card ) {
				this.close(this.openCard, false);
			}

			const strip = card.querySelector('[data-category-strip]');
			const track = card.querySelector('[data-category-track]');

			card.classList.add('is-open');
			card.querySelector('[data-category-toggle]').setAttribute('aria-expanded', 'true');
			card.querySelector('[data-category-close]').hidden = false;
			strip.hidden = false;
			if ( track ) track.scrollLeft = 0;

			this.openCard = card;
			this.setAttribute('data-has-open', '');

		}

		close(card, restoreFocus){

			const toggle = card.querySelector('[data-category-toggle]');

			card.classList.remove('is-open');
			toggle.setAttribute('aria-expanded', 'false');
			card.querySelector('[data-category-close]').hidden = true;
			card.querySelector('[data-category-strip]').hidden = true;

			if ( this.openCard === card ) this.openCard = null;
			if ( ! this.openCard ) this.removeAttribute('data-has-open');
			if ( restoreFocus ) toggle.focus();

		}

		onBlockSelect(e){
			const card = this.cards.find(c => c.id === `element-${e.detail.blockId}`);
			if ( card ) this.open(card);
		}

		onBlockDeselect(e){
			const card = this.cards.find(c => c.id === `element-${e.detail.blockId}`);
			if ( card && card === this.openCard ) this.close(card, false);
		}

	}

	customElements.define('category-preview', CategoryPreview);

}
